import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { Button, FormLayout, Heading, Input, Select } from "@/ui";
import { useForm, useValidator } from "@/hooks";
import { EVENT_TYPE } from "../../config/constant";
import styles from "./SwifterForm.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const SettingForm = ({
    app,
    handleCancel,
    handlerUpdatingOrCreate,
    isCreate,
    isUpdating,
    selectSettings,
    setSettings,
}) => {
    const [isFormReset, resetFormInputs] = useState(isCreate);
    const { inputs, inputChange, setInputs } = useForm();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "campaign_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Campaign is required.",
            },
            {
                field: "event_type",
                method: "isEmpty",
                validWhen: false,
                message: "This Event type is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    useEffect(() => {
        if (!isCreate) {
            const objSelect = app?.settings[selectSettings];
            setInputs({
                campaign_id: objSelect?.campaign_id,
                event_type: objSelect?.event_type,
                event_name: objSelect?.event_name,
                schedule_send_email_hours: objSelect?.schedule_send_email_hours,
            });
        }
    }, []);

    if (!isCreate && !isFormReset) {
        resetFormInputs(true);
    }

    const createOrUpdate = async () => {
        if (isSubmited) {
            isSubmited(true);
        }

        if (isValid()) {
            let newSettings = _.cloneDeep(app.settings);

            if (isCreate) {
                newSettings.push({
                    campaign_id: parseInt(inputs.campaign_id),
                    event_type: inputs.event_type,
                    event_name: inputs.event_name,
                    schedule_send_email_hours: parseInt(
                        inputs.shedule_send_email_hours || 0,
                    ),
                });
            } else {
                newSettings[selectSettings] = {
                    ...inputs,
                    schedule_send_email_hours: parseInt(
                        inputs.schedule_send_email_hours || 0,
                    ),
                };
            }
            setSettings(newSettings);
            handlerUpdatingOrCreate(newSettings);
        }
    };

    const handleClose = () => {
        handleCancel();
        resetFormInputs(false);
    };

    const eventTypeOptions = useMemo(
        () =>
            (EVENT_TYPE || []).map(option => ({
                value: String(option.value),
                label: option.label,
            })),
        [],
    );

    const handleEventTypeChange = value => {
        const option = (EVENT_TYPE || []).find(
            item => String(item.value) === value,
        );
        setInputs({
            ...inputs,
            event_type: option ? option.value : value,
        });
    };

    return (
        <div className={styles.credentialForm}>
            <Heading level={5}>
                {isCreate ? "Add Setting" : "Update Setting"}
            </Heading>

            <FormLayout>
                <FormLayout.Section>
                    <FormLayout.Grid columns={2} maxWidth="twoThirds">
                        <Input
                            error={fieldError(validator, "campaign_id")}
                            fullWidth
                            label="Campaign number"
                            name="campaign_id"
                            onChange={inputChange}
                            placeholder="Campaign number"
                            type="number"
                            value={inputs.campaign_id ?? ""}
                        />
                        <Select
                            error={fieldError(validator, "event_type")}
                            fullWidth
                            label="Event type"
                            onValueChange={handleEventTypeChange}
                            options={eventTypeOptions}
                            placeholder="Event type"
                            value={
                                inputs.event_type != null &&
                                inputs.event_type !== ""
                                    ? String(inputs.event_type)
                                    : undefined
                            }
                        />
                        <Input
                            fullWidth
                            label="Event name"
                            name="event_name"
                            onChange={inputChange}
                            placeholder="Event name"
                            value={inputs.event_name || ""}
                        />
                        <Input
                            fullWidth
                            label="Schedule send email hours"
                            name="schedule_send_email_hours"
                            onChange={inputChange}
                            placeholder="Schedule send email hours"
                            type="number"
                            value={inputs.schedule_send_email_hours ?? ""}
                        />
                    </FormLayout.Grid>
                </FormLayout.Section>
            </FormLayout>

            <div className={styles.credentialActions}>
                <Button
                    disabled={isUpdating}
                    onClick={handleClose}
                    type="button"
                    variant="secondary"
                >
                    Cancel
                </Button>
                <Button
                    loading={isUpdating}
                    onClick={createOrUpdate}
                    type="button"
                >
                    Save
                </Button>
            </div>
        </div>
    );
};

export default SettingForm;
